// @flow
import type { FileType } from './reducer';

export type FilesActionType =
  | {|
      type: 'FETCH_FILES',
      payload: {|
        beginDate?: number,
        endDate?: number,
      |},
    |}
  | {|
      type: 'SET_FILES',
      payload: {|
        files: FileType[],
      |},
    |};

export const fetchFiles = (beginDate?: number, endDate?: number): FilesActionType => ({
  type: 'FETCH_FILES',
  payload: { beginDate, endDate },
});

export const setFiles = (files: FileType[]): FilesActionType => ({
  type: 'SET_FILES',
  payload: { files },
});
